var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uF7E4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sparta-Phase-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99998122,18.2499946 C12.3491492,18.2499946 15.8749624,14.6236224 15.8749624,10.1500002 C15.8749624,8.27724772 14.0475285,4.41463562 11.500114,2.05004013 C10.7688726,2.72854727 10.1086646,3.44186725 9.52364397,4.1583458 C8.56529512,2.83823863 7.37702357,1.49914575 6.03123592,0.250037551 C2.57679927,3.45522248 0.125,7.63142483 0.125,10.1500002 C0.125,14.6236224 3.65081328,18.2499946 7.99998122,18.2499946 Z M7.99998122,16.5624987 C4.58808216,16.5624987 1.81249598,13.6856668 1.81249598,10.1500002 C1.81249598,8.55499517 3.36990727,5.46684869 6.0368664,2.62342209 C6.82224966,3.44468249 7.54226442,4.30109906 8.15818397,5.14975655 L9.4456069,6.92301435 L10.8311169,5.22532171 C11.0360801,4.97397572 11.2477037,4.72788256 11.4642712,4.48810652 C13.0937458,6.50642751 14.1874665,9.05384194 14.1874665,10.1500002 C14.1874665,13.6856668 11.4118803,16.5624987 7.99998122,16.5624987 Z M8.08787164,14.8750027 C8.97590816,14.8750027 9.79716856,14.5983195 10.4637281,14.132157 C11.9782585,13.0725625 12.333322,11.0180211 11.4923893,9.41278502 C11.3886717,9.21520325 11.2730066,9.00921009 11.1453938,8.79861641 L9.34188934,10.8559388 C9.34188934,10.8559388 6.5146332,7.24542798 6.30160194,7.00002146 C4.81024579,8.78807643 4.06249061,9.8343157 4.06249061,11.0222439 C4.06249061,13.4065461 5.86846699,14.8750027 8.08787164,14.8750027 Z",
    id: "\\uF7E4",
    fill: "#247F38",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlames);
export default __webpack_public_path__ + "static/media/flames.207d069d9f83a829f128cc9aa167d09d.svg";
export { ForwardRef as ReactComponent };